import React from "react";

import { isMiniSize, debounce } from "@/utils";

class BlankSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 0,
    };

    this.resizeDebounce = debounce(this.resize);
  }

  componentDidMount() {
    this.resize();
    window.addEventListener("resize", this.resizeDebounce);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeDebounce);
    this.resizeDebounce.cancel();
  }

  resize = () => {
    const { fields } = this.props;
    this.setState({
      height: `${
        isMiniSize()
          ? fields?.spHeight?.value || 24
          : fields?.height?.value || 40
      }px`,
    });
  };

  render() {
    const { height } = this.state;
    return (
      <div
        style={{
          height,
        }}
      />
    );
  }
}

export default BlankSection;
